import React from "react";

function Appointment(props) {
  return <h1>Appointment Page</h1>;
}

export default Appointment;